import { ItemModel } from '../../item.model';
import { ActionTypesEnum } from '../ActionTypesEnum';
import { ActionModel } from './ActionModel';

export class LowerCaseAction extends ActionModel {
  override type = ActionTypesEnum.lower;
  override value = null;

  isValid(): boolean {
    return !!this.columnName;
  }

  use(item: ItemModel) {
    const str = item[this.columnName as keyof typeof item] as string;
    return str ? str.toLowerCase() : str;
  }

  returnForSend() {
    return {
      action: this.type,
      param: this.columnName,
      sequence: this.sequence,
    };
  }

  copyValue(item: this, overrideManualChanges: boolean): void {
    this.columnName = item.columnName;
    this.override_manual_changes = overrideManualChanges;
  }
}
